import { render, staticRenderFns } from "./SimpleChip.vue?vue&type=template&id=3eac7d2a&"
import script from "./SimpleChip.vue?vue&type=script&lang=ts&"
export * from "./SimpleChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports